



































import { computed, defineComponent } from '@vue/composition-api';
import {
  show,
  text,
  button,
  buttonIcon,
  soloIcon,
  loading,
  callback,
  timeout,
  options,
} from './state';

export default defineComponent({
  name: 'Snackbar',
  setup() {
    const buttonExists = computed(() => button.value || buttonIcon.value);
    function buttonClicked() {
      if (callback.value !== null) {
        callback.value();
      }

      show.value = false;
    }

    return {
      show,
      text,
      button,
      buttonIcon,
      soloIcon,
      loading,
      buttonExists,
      callback,
      timeout,
      options,
      buttonClicked,
    };
  },
});
